import { Button, Select, Space } from "antd"
import React, { useEffect, useState } from "react"
import Modal from "../../components/modal/DraggableModal"   // talabnoma §8.2 (2026-09-06): siljitiladigan modal
import { LeftOutlined, RightOutlined, MessageOutlined } from "@ant-design/icons"
import TodoList from "./TodoList"
import { useTranslation } from "react-i18next"
import { PageInfo } from "../../rest-api/fragments/types/PageInfo"
import useQueryParams from "../../hooks/useQueryParams"
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint"
import "./pagenation.css"
import getPerPage from "../../utils/getPerPage"
export interface IPaginationProps extends PageInfo {
  name: string
  pages?: number[]
  pageInfo: any
}

export default function Pagination(props: IPaginationProps) {
  const { t } = useTranslation()
  const { lg, sm } = useBreakpoint()
  // tog'a #3353 (2026-10-04): telefonda (xs) «Страница 1 из 0» ikki qatorga bo'linib, «›» ekran chetida kesilardi — ixcham «‹ 1 / N ›»
  const tor = sm === false
  const query = useQueryParams()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleOk = () => {
    setIsModalVisible(false)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }
  // Boshliq (2026-09-03): har bo'limda 100, 500 va «Hammasi» tanlovi bo'lsin. R-EGA-100500
  // «Hammasi» = serverdagi eng katta ruxsat etilgan sahifa (PaginationFilter.MaxPageSize),
  // ya'ni server baribir chegarani ushlab turadi — cheksiz so'rov ketmaydi.
  const ALL_PER_PAGE = 100000
  const pages = props.pages || [5, 10, 20, 30, 40, 50, 100, 500, ALL_PER_PAGE]
  // tog'a 1377 (2026-09-05): «Страница 4 из 2» — sahifa raqami totalPages'dan katta bo'lib qolsa (filtr/sahifa o'lchami o'zgarganda) oxirgi sahifaga qaytariladi
  const totalPages = Number(props?.pageInfo?.totalPages || 0)
  const currentPage = Number(query.secureGet(props.name + "pageNumber")) || 1
  useEffect(() => {
    if (totalPages >= 1 && currentPage > totalPages) query.set(props.name + "pageNumber", String(totalPages))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalPages, currentPage])

  return (
    <>
      <Modal visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
        <TodoList />
      </Modal>
      <Space size={tor ? 6 : 15} className={tor ? "pg-compact" : undefined}>
        {(query.has(props.name + "after") ||
          query.has(props.name + "before")) && (
          <Button
            onClick={() =>
              query.removeMany(
                props.name + "after",
                props.name + "before",
                props.name + "perPage"
              )
            }
            size={lg ? "large" : "middle"}
            type="primary"
          >
            {t("reset")}
          </Button>
        )}
        <Select
          size={lg ? "large" : "middle"}
          onChange={(value) =>
            query.multiple({
              // tog'a #4152 (2026-10-12): qatorlar soni o'zgarsa — 1-sahifadan (aks holda 2-sahifada «20/ст» tanlansa 1 ta qator ko'rinib, «ishlamayapti» deb o'qilardi)
              remove: `${props.name}before,${props.name}after,${props.name}pageNumber`,
              set: { [`${props.name}perPage`]: value },
            })
          }
          style={{ width: tor ? "88px" : "120px" }}   // «Hammasi» sig'ishi uchun; telefonda ixcham
          value={getPerPage(props.name, props.pages ? pages[0] : lg ? 10 : 5)}
        >
          {pages?.map((x, i) => (
            <Select.Option value={x} key={i}>
              {x === ALL_PER_PAGE ? t("all") : `${x}/${t("page")}`}
            </Select.Option>
          ))}
        </Select>

        <Space size={tor ? 4 : 8}>
          <Button
            size={lg ? "large" : "middle"}
            disabled={!props?.pageInfo?.previousPage}
            onClick={() =>
              query.multiple({
                remove: `${props.name}after`,
                set: {
                  [`${props.name}pageNumber`]:
                    Number(query.secureGet(props.name + "pageNumber")) - 1 ||
                    "",
                },
              })
            }
            icon={
              <LeftOutlined style={{ fontSize: "12px", color: "var(--zd-ink)" }} />
            }
          />

          {tor ? (
            <p className="pg-compact-num" data-testid="pg-compact">{query.secureGet(props.name + "pageNumber").toString() || 1} / {props?.pageInfo?.totalPages || 0}</p>
          ) : (<>
          <p>{t("pageWord")}</p>
          <Button size={lg ? "large" : "middle"}>
            {query.secureGet(props.name + "pageNumber").toString() || 1}
          </Button>
          <p>{t("ofWord")} {props?.pageInfo?.totalPages}</p>
          </>)}
          <Button
            size={lg ? "large" : "middle"}
            disabled={!props?.pageInfo?.nextPage}
            onClick={() =>
              query.multiple({
                remove: `${props.name}before`,
                set: {
                  // tog'a #4147/#4152 (2026-10-12): URL'da sahifa raqami yo'q = 1-sahifa (usePagination ham shunday o'qiydi).
                  // Avval Number("") + 1 = 1 chiqib, «›» ning BIRINCHI bosilishi yana 1-sahifani ochardi.
                  [`${props.name}pageNumber`]:
                    (Number(query.secureGet(props.name + "pageNumber")) || 1) + 1,
                },
              })
            }
            icon={
              <RightOutlined style={{ fontSize: "12px", color: "var(--zd-ink)" }} />
            }
          />
          <Button
            size={lg ? "large" : "middle"}
            onClick={showModal}
            icon={
              <MessageOutlined style={{ fontSize: "15px", color: "var(--zd-ink)" }} />
            }
          />
        </Space>
      </Space>
    </>
  )
}
